"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateAssesseeNo = validateAssesseeNo;
exports.validateInstrumentNo = validateInstrumentNo;
exports.validateAssesseeNumber = validateAssesseeNumber;
exports.validateSAFNo = validateSAFNo;
exports.validatePastDate = validatePastDate;
exports.validateOnlyFutureDate = validateOnlyFutureDate;
exports.validateOnlyPastDate = validateOnlyPastDate;
exports.validateSpecialChar = validateSpecialChar;
exports.isValidPercentage = isValidPercentage;
var isValidEmail = exports.isValidEmail = function isValidEmail(email) {
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

var isValidMobileNumber = exports.isValidMobileNumber = function isValidMobileNumber(mobileNumber) {
    var regex = /^\d{10}$/;
    return regex.test(mobileNumber);
};

// check a valid year
var isValidYear = exports.isValidYear = function isValidYear(year) {
    var yearPattern = /^\d{4}$/;

    return yearPattern.test(year);
};

// pincode validation
var isValidPincode = exports.isValidPincode = function isValidPincode(pincode) {
    var pinPattern = /^\d{6}$/;
    return pinPattern.test(pincode);
};

var isValidQuarter = exports.isValidQuarter = function isValidQuarter(quarter) {
    var regex = /^[1-4]\/\d{4}$/;
    return regex.test(quarter);
};

var blockInvalidChar = exports.blockInvalidChar = function blockInvalidChar(e) {
    return ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
};

var blockInvalidCharForName = exports.blockInvalidCharForName = function blockInvalidCharForName(event) {
    // Allowed key codes for alphabets, spaces, and hyphens
    var allowedKeyCodes = [32, 45]; // 32: Space, 45: Hyphen

    // Allow key codes for alphabets (A-Z and a-z)
    for (var i = 65; i <= 90; i++) {
        allowedKeyCodes.push(i);
    }
    for (var _i = 97; _i <= 122; _i++) {
        allowedKeyCodes.push(_i);
    }

    // Allow navigation keys and modifier keys
    var allowedNavigationKeys = [8, 9, 13, 37, 38, 39, 40]; // Backspace, Tab, Enter, Arrow keys

    if (!(allowedKeyCodes.includes(event.keyCode) || // Allow alphabets, spaces, and hyphens
    allowedNavigationKeys.includes(event.keyCode) || // Allow navigation keys
    event.ctrlKey || // Allow Ctrl key combinations
    event.metaKey) // Allow Cmd key combinations (for macOS)
    ) {
            event.preventDefault(); // Prevent default action for other keys
        }
};

// validate common hearing case number
var validateHearingCaseNo = exports.validateHearingCaseNo = function validateHearingCaseNo(value) {
    var caseRefRegex = /^HEARING\/\d{4}\/\d{6}$/; // Regex pattern for validation
    if (!caseRefRegex.test(value)) {
        return false;
    } else {
        return true;
    }
};

// validate Lok adalat hearing case number
var validateLokAdalatHearingCaseNo = exports.validateLokAdalatHearingCaseNo = function validateLokAdalatHearingCaseNo(value) {
    var caseRefRegex = /^PL\/\d{4}\/\d{6}$/; // Regex pattern for validation
    if (!caseRefRegex.test(value)) {
        return false;
    } else {
        return true;
    }
};

// validate assessee no
function validateAssesseeNo(input) {
    // Define a regular expression for exactly 12 digits
    var twelveDigitRegex = /^\d{12}$/;

    return twelveDigitRegex.test(input);
}

// validate instrument no (6digit)
function validateInstrumentNo(input) {
    var sixDigitRegex = /^\d{6}$/;

    return sixDigitRegex.test(input);
}
function validateAssesseeNumber(assesseeNo) {
    var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (isRequired && !assesseeNo) {
        return "Assessee Number is required.";
    } else if (assesseeNo && !/^\d{12}$/.test(assesseeNo)) {
        return "Assessee Number must be exactly 12 digits.";
    }
    return "";
}

// validate saf no
function validateSAFNo(input) {
    // Regular expression to match the SAF number format
    var regex = /^\d{3}\/\d{2}\/\d{4}-\d{4}\/\d{7}$/;

    // Check if the input matches the regex pattern
    return regex.test(input);
}
// allow only future and current date
function validatePastDate(input) {
    var inputDate = new Date(input);
    var currentDate = new Date();
    // Set the time of current date to midnight to only compare dates, not times
    currentDate.setHours(0, 0, 0, 0);
    return inputDate >= currentDate;
}
//  allow only future date
function validateOnlyFutureDate(dateString) {
    var inputDate = new Date(dateString);
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);
    // Check if the input date is less than or equal to today's date
    return inputDate > today;
}
//  allow only past date
function validateOnlyPastDate(dateString) {
    var inputDate = new Date(dateString);
    var today = new Date();

    // Set time to midnight for both dates to compare dates only, not time
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    // Check if the input date is strictly less than today's date
    return inputDate < today;
}
//  restrict the special char in name input
function validateSpecialChar(input) {
    var regex = /^[a-zA-Z\s-]*$/;
    return regex.test(input);
}
// validate percentage for rate(40% max)
function isValidPercentage(value) {
    var rate = value ? parseFloat(value) : 0;

    // Check if the value is within the range of 0 to 40
    return rate >= 0 && rate <= 40;
}
// validate BI Code (Ex. 2 digit-4 digit-4 digit)
var validateBICode = exports.validateBICode = function validateBICode(value) {
    var regex = /^\d{2}-\d{4}-\d{4}$/;
    return regex.test(value);
};

//  function checks if a number has up to two decimal places.
var validateDecimalPlaces = exports.validateDecimalPlaces = function validateDecimalPlaces(value) {
    var parsedValue = parseFloat(value);
    if (isNaN(parsedValue) || parsedValue * 100 % 1 !== 0) {
        return false;
    }
    return true;
};

// Validate Assessee No
var validationForAssesseeNo = exports.validationForAssesseeNo = function validationForAssesseeNo(assesseeNo) {
    if (!assesseeNo) {
        return "Assessee No is required";
    }
    if (assesseeNo.length !== 12) {
        return "Assessee No must be exactly 12 digits";
    }
    return ""; // No error
};

// Handle Assessee No change with validation
var handleAssesseeNoChange = exports.handleAssesseeNoChange = function handleAssesseeNoChange(e, setStateFn, validateFn) {
    if (!e || !e.target || !e.target.value) {
        return;
    }

    var value = e.target.value.trim();
    if (/^\d{0,12}$/.test(value)) {
        var error = validateFn(value);
        setStateFn({ assesseeNo: value, assesseeNoError: error });
    }
};


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/utils/validations.js
// module id = 2189
// module chunks = 1137